export default 'Your entry does not match the allowed format {0}.';